export const rgbaToHex = (rgbaColor) => {
  let a,
    rgb = rgbaColor
      .replaceAll(/\s/g, "")
      .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
    alpha = ((rgb && rgb[4]) || "").trim(),
    hex = rgb
      ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
        (rgb[2] | (1 << 8)).toString(16).slice(1) +
        (rgb[3] | (1 << 8)).toString(16).slice(1)
      : rgbaColor;

  if (alpha !== "") {
    a = alpha;
  } else {
    a = 0o1;
  }
  // multiply before convert to HEX
  a = ((a * 255) | (1 << 8)).toString(16).slice(1);
  hex = hex + a;

  return `#${hex}`;
};

export const hexToRgba = (hexColor) => {
  let r,
    g,
    b = 0;

  if (hexColor.length >= 7) {
    r = parseInt(hexColor.slice(1, 3), 16);
    g = parseInt(hexColor.slice(3, 5), 16);
    b = parseInt(hexColor.slice(5, 7), 16);

    if (hexColor.length === 9) {
      let alpha =
        Math.round((parseInt(hexColor.slice(7, 9), 16) / 255) * 10) / 10;
      return {
        r,
        g,
        b,
        a: alpha,
      };
    } else {
      return {
        r,
        g,
        b,
        a: 1,
      };
    }
  } else if (hexColor.length === 4) {
    r = parseInt(hexColor[1] + hexColor[1], 16);
    g = parseInt(hexColor[2] + hexColor[2], 16);
    b = parseInt(hexColor[3] + hexColor[3], 16);

    return {
      r,
      g,
      b,
      a: 1,
    };
  }
};
